import { environment as coreEnvironment } from '@portal-core/environment/environment';
import { Environment } from '@portal-core/environment/environment.model';

// Deployment-time overrides. Nothing in this workspace assigns mcEnvironment: inject-env.sh in
// MadCloud.Web.Tools/bash writes `<script>window.mcEnvironment={...}</script>` into the built
// index.html from the MC_* env vars (prefix stripped, camelCased), so its keys are Environment
// keys. Reached through `self` here, the same object as `window` on the main thread (the four
// other apps spell it `window`). Typed rather than `any` so the spread below is checked.
declare const self: { mcEnvironment?: Partial<Environment> };

export const environment: Environment = {
  ...coreEnvironment,
  apiServiceBaseUri: process.env.MC_API_SERVICE_BASE_URI, // For the old portal
  authorizeApiLoginId: process.env.MC_AUTHORIZE_API_LOGIN_ID,
  authorizeClientKey: process.env.MC_AUTHORIZE_CLIENT_KEY,
  authorizeSandbox: process.env.MC_AUTHORIZE_SANDBOX === 'true',
  googleAnalyticsMeasurementId: process.env.MC_GOOGLE_ANALYTICS_MEASUREMENT_ID,
  slackAppClientId: process.env.MC_SLACK_APP_CLIENT_ID,
  ...self.mcEnvironment
};
